<!-- Overlay + modal auto-hospedado. Se muestra solo cuando isVisible && config. -->
<div class="onboarding-modal-overlay" *ngIf="isVisible && config" (click)="close()">
    <div class="onboarding-modal" [ngClass]="'theme-' + theme" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
        <!-- Cabecera: trofeo con halo + sparkles decorativos -->
        <div class="onboarding-modal__header">
            <span class="onboarding-modal__spark onboarding-modal__spark--1" aria-hidden="true">+</span>
            <span class="onboarding-modal__spark onboarding-modal__spark--2" aria-hidden="true">+</span>
            <span class="onboarding-modal__spark onboarding-modal__spark--3" aria-hidden="true">+</span>

            <div class="onboarding-modal__halo">
                <div class="onboarding-modal__badge">
                    <svg class="onboarding-modal__trophy" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M18 2H6v2H2v3a4 4 0 0 0 4 4 6 6 0 0 0 5 5.91V19H8v2h8v-2h-3v-2.09A6 6 0 0 0 18 11a4 4 0 0 0 4-4V4h-4V2zM4 7V6h2v3a2 2 0 0 1-2-2zm16 0a2 2 0 0 1-2 2V6h2v1z" />
                    </svg>
                </div>
            </div>
        </div>

        <!-- Cuerpo -->
        <div class="onboarding-modal__body">
            <p class="onboarding-modal__eyebrow"><span class="dash"></span> {{ config.eyebrow }} <span class="dash"></span></p>

            <h2 class="onboarding-modal__title">{{ config.title }}</h2>
            <p class="onboarding-modal__subtitle" *ngIf="config.subtitle">{{ config.subtitle }}</p>

            <!-- Métrica única: tareas completadas / total de la fase, tomada del state$ real. -->
            <div class="onboarding-modal__stats">
                <div class="stat">
                    <span class="stat__value">{{ tasksDone }}/{{ tasksTotal }}</span>
                    <span class="stat__label">TAREAS COMPLETADAS</span>
                </div>
            </div>

            <!-- Acciones -->
            <div class="onboarding-modal__actions">
                <button *ngIf="config.secondary_cta" type="button" class="btn btn--secondary" (click)="onSecondaryClick()">{{ config.secondary_cta.label }}</button>
                <button type="button" class="btn btn--primary" (click)="onPrimaryClick()">
                    {{ config.primary_cta.label }}
                    <span class="btn__arrow" aria-hidden="true">→</span>
                </button>
            </div>
        </div>
    </div>
</div>
